<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container-fluid">
    <Breadcrumbs main="Monitoring Periods" :path="breadcrumbPath" />
    <el-row class="m-0 width-100-p mt-3">
      <el-col class="d-flex align-item-center px-2" :span="24">
        <div class="row m-0 width-100-p px-2">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >
            <el-row :gutter="$vuetify.display.width > 1200 ? 20 : 0">
              <!-- search bay -->
              <el-col
                    :span="$vuetify.display.width > 1200 ? 16 : 24"
                    :class="$vuetify.display.width > 1200 ? 'x-start order-1 mb-10' : 'x-start order-3 mb-10'"
                  >
                    <el-input
                      size="large"
                      v-model="search"
                        :placeholder="selectedSearchBy != '' ? 'Search by ' + (convertLabel(selectedSearchBy)) : 'Choose a search by options' "
                        :prefix-icon="Search"
                        class="mixedSearchBar"
                        id="mixedSearchBar-input"
                        clearable
                        @clear="handleReload"
                    >
                      <template #prepend>

                        <!-- search_by select -->
                        <el-tooltip
                          effect="light"
                          placement="top"
                          show-after="500"
                          hide-after="300"
                          >
                          <template #content > 
                              <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select Search by" }} </span>
                          </template>

                          <el-select
                            v-model="selectedSearchBy"
                            placeholder="Select"
                            style="min-width: 117px; height: 40px;"
                            @change="handleSelectSearchBy"
                            class="mixedSearchBar-select"
                          >
                            <!-- <template #label>
                              <span>Search by: </span>
                              <span style="font-weight: bold">{{ convertLabel(selectedSearchBy) }}</span>
                            </template> -->
                            <el-option
                              v-for="(item, index) in search_by_dropdown['selectedTableTab']"
                              :key="index"
                              :label="convertLabel(item)"
                              :value="item"
                            />
                          </el-select>
                        </el-tooltip>
                      </template>
                      
                      <template #append>
                        <!-- <el-button :icon="Search" /> -->
                        <el-button
                            @click.stop="handleReload"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                      </template>
                    </el-input>

              </el-col>

              <!-- export button -->
              <el-col
                    :class="$vuetify.display.width > 1200 ? 'd-flex justify-content-end order-2' : 'd-flex justify-content-end order-1 mb-20'"
                    :span="$vuetify.display.width > 1200 ? 8 : 24"
                  >
                  <el-button
                      v-if="
                          $store.state.auth.user != null &&
                          !$store.state.auth.user.is_auditor
                        "
                      @click.stop="handleNew"
                      class="newAddButtonNoText new-button-behavior x-end"
                      size="small"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newAddButtonNoText"></use>
                        </svg>
                    </el-button>
                    <el-button
                      @click.stop="handleExportFile"
                      class="new-download-file-btn new-button-behavior x-end"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                        </svg>
                    </el-button>
              </el-col>
            </el-row>

            <DataTable
              :loadingProp="loading"
              :usersDataProp="filter_monitoring"
              :totalRowProp="total_items"
              @tableAction="handleTableAction"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <ShowDetail
      :open_modal="show_modal"
      :data_modal="data_modal"
      @close_modal="close_modal"
      @confirm_modal="confirm_modal"
      @handleReload="handleReload"
      @checkCurrentMP="checkCurrentMP"
      @checkRevisionUnderAuditMP="checkRevisionUnderAuditMP"
      @checkRevisionIssueRequestedMP="checkRevisionIssueRequestedMP"
      @bypassAllowSubmitCheck="bypassAllowSubmitCheck"
      :allowSubmitProp="allowSubmit"
    />

  </div>
</template>

<script>
import Breadcrumbs from "../../components/bread_crumbs.vue";
// import XLSX from "xlsx";
import { exportToExcel } from "../dashboard/common/exportExcel";
import UserService from "../../services/user.service";
import DataTable from "./dataTable.vue";
import ShowDetail from "./dialogDetail.vue";
import { ElMessageBox } from "element-plus";
import { convertToTitleCase } from "../dashboard/common/common-tools";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "monitoring-periods",
  components: {
    Breadcrumbs,
    // Filter,
    ShowDetail,
    DataTable,
  },
  data() {
    return {

      search_by_dropdown: 
        {
          selectedTableTab: [
            'name',
            'status',
            'start_date',
            'end_date',
          ],
        },

      selectedSearchBy: 'name',
      search: "",
      
     
      breadcrumbPath: [
        {
          title: "Input",
          disabled: true,
          href: "",
        },
        {
          title: "Monitoring Periods",
          disabled: false,
          href: "/monitoring-periods",
          active: true,
        },
      ],

      show: true,
      monitoringDataList: [],
      
      current_page: 1,
      page_size: 20,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,

      allowSubmit: true,
    };
  },
  watch: {},
  computed: {
    filter_monitoring() {
      return this.monitoringDataList;
    },
  },
  mounted() {

    

    this.fetchMonitoringData(this.current_page);
  },
  methods: {

    convertLabel(str) {
      return convertToTitleCase(str);
    },

    handleSelectSearchBy(search_by){
      this.selectedSearchBy = search_by;
    },



    async fetchMonitoringData(page) {
      UserService.getMonitoringPeriods(
        this.selectedSearchBy,
        this.search,
        page,
        this.perPageCount
      )
        .then(
          (response) => {
            this.monitoringDataList = response.data.monitoring_periods;
            this.total_items = response.data.total_record;

            // localStorage.setItem(
            //   "monitoringPeriods",
            //   JSON.stringify(this.monitoringDataList)
            // );
            sessionStorage.setItem(
              "monitoringPeriods",
              JSON.stringify(this.monitoringDataList)
            );

          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    DeleteMonitoring(user, index) {
      UserService.DeleteMonitoringPeriod(user.id)
        .then(
          // eslint-disable-next-line no-unused-vars
          (response) => {
            this.monitoringDataList.splice(index, 1);
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => {
          this.loading = false;
          this.handleReload();
        }
        );
    },
    // eslint-disable-next-line no-unused-vars
    handleRowClick(row, column, event) {
      // console.log(row, column, event);
    },
    // eslint-disable-next-line no-unused-vars
    close_modal(event) {
      this.show_modal = false;
    },

    confirm_modal(event) {
      if (this.monitoringDataList.length == this.current_row_index)
        this.monitoringDataList.push(event);
      else this.monitoringDataList[this.current_row_index] = event;
      this.show_modal = false;
    },

    handleShow(index, data) {
      this.current_row_index = index;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },

    checkCurrentMP(){
      let current = this.monitoringDataList.filter((item) => item.status == "current");
      console.log(current);
      if (current.length > 0) {
          ElMessageBox.alert("There is already a current monitoring period", "Warning", {
            confirmButtonText: "OK",
            type: "warning",
          }).then(()=> {this.allowSubmit = false; return;}).catch(()=>{return;});
        } else {
          this.allowSubmit = true;
          return;
        }
    },

    checkRevisionUnderAuditMP(){
      let revisionUnderAudit = this.monitoringDataList.filter((item) => item.status == "revision_under_audit");
      console.log(revisionUnderAudit);
      if (revisionUnderAudit.length > 0) {
        ElMessageBox.alert("There is already a revision under audit monitoring period", "Warning", {
          confirmButtonText: "OK",
          type: "warning",
        }).then(()=> {this.allowSubmit = false; return;}).catch(()=>{return;});
      } else {
        this.allowSubmit = true;
        return;
      }
    },

    checkRevisionIssueRequestedMP(){
      let revisionIssueRequested = this.monitoringDataList.filter((item) => item.status == "revision_issue_requested");
      console.log(revisionIssueRequested);
      if (revisionIssueRequested.length > 0) {
        ElMessageBox.alert("There is already a revision issue requested monitoring period", "Warning", {
          confirmButtonText: "OK",
          type: "warning",
        }).then(()=> {this.allowSubmit = false; return;}).catch(()=>{return;});
      } else {
        this.allowSubmit = true;
        return;
      }
    },

    bypassAllowSubmitCheck(){
      this.allowSubmit = true;
    },

    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },

    async handleExportFile() {
      await UserService.getMonitoringPeriods(
        this.selectedSearchBy,
        this.search,
        1,
        this.perPageCount,
        true
      ).then(
        async (response) => {
        let dataList = response.data.monitoring_periods;
        
        if (dataList.length > 0) {
          const skipKeys = ["id", "status"]; // Keys to skip
          const fileName = "MonitoringPeriodsList.xlsx"; // File name
          const newWorksheetName = "Monitoring Periods List"; // Worksheet name
          const title = "Monitoring Periods List"; // Title for the Excel file
          try {
          await exportToExcel({
            dataList,
            skipKeys,
            fileName,
            newWorksheetName,
            title,
          });
        } catch (err) {
          console.log("error when export excel", err.message);
          
        }
          } else {
            console.log("empty data list");
          }
      })

    },

    // handleExportFile() {
    //   if (this.filter_monitoring.length > 0) {
    //     const myHeader = ["start_date", "end_date", "status"];
    //     const ws = XLSX.utils.json_to_sheet(this.filter_monitoring, {
    //       header: myHeader,
    //     });
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Data");
    //     XLSX.writeFileXLSX(wb, "MonitoringPeriodsList.xlsx");
    //   }
    // },

    reset_filter(event) {
      this.current_page = 1;
      this.search = "";
      this.filter = event.filter;
    },

    handleTableAction(event) {
      if (event.kind == "edit") {
        this.handleShow(event.index, event.data);
      } else if (event.kind == "delete") {
        this.deleteRow(event.data, event.index);
      } else if (event.kind == "changePage") {
        this.current_page = event.index;
        this.fetchMonitoringData(this.current_page);
      } else if (event.kind == "perPageChange") {
        this.current_page = 1;
        this.perPageCount = event.index;
        this.handleReload();
      }
    },

    handleReload() {
      this.fetchMonitoringData(this.current_page);
    },
    handleNew() {
      let data = {
        start_date: null,
        end_date: null,
        status: "",
        id: 0,
      };
      this.current_row_index = this.monitoringDataList.length;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },
    filterSearch(event) {
      this.search = event.search;
    },

    deleteRow(event, index) {
      console.log(event, index);
      ElMessageBox.confirm("Are you sure to delete this?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "Confirm Delete",
      })
        .then(() => {
          this.DeleteMonitoring(event, index);
          // ElMessage({
          //   type: "success",
          //   message: "Delete completed",
          // });
        })
        .catch(() => {
          // ElMessage({
          //   type: "info",
          //   message: "Delete canceled",
          // });
        });
    },
  },
};
</script>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-8);
}
.el-table .error-row {
  --el-table-tr-bg-color: var(--el-color-error-light-8);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.cell {
  text-align: center !important;
}

.starter-main .card-body ul {
  list-style-type: none !important;
}

.el-pager {
  -webkit-user-select: none !important;
  user-select: none !important;
  list-style: none !important;
  font-size: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
}

.el-upload-list {
  margin: 10px 0 0 !important;
  padding: 0 !important;
  list-style: none !important;
  position: relative !important;
}
</style>
